import { render, staticRenderFns } from "./common.vue?vue&type=template&id=0edc6ce1&scoped=true&"
import script from "./common.vue?vue&type=script&lang=js&"
export * from "./common.vue?vue&type=script&lang=js&"
import style0 from "./common.vue?vue&type=style&index=0&id=0edc6ce1&lang=scss&scoped=true&"
import style1 from "./common.vue?vue&type=style&index=1&id=0edc6ce1&lang=scss&"
import style2 from "./common.vue?vue&type=style&index=2&id=0edc6ce1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edc6ce1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0edc6ce1')) {
      api.createRecord('0edc6ce1', component.options)
    } else {
      api.reload('0edc6ce1', component.options)
    }
    module.hot.accept("./common.vue?vue&type=template&id=0edc6ce1&scoped=true&", function () {
      api.rerender('0edc6ce1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/goods/freight/common.vue"
export default component.exports